module.exports = __webpack_public_path__ + "img/13-img.f1ba0e3d.jpg";